import React, { SVGProps } from 'react';

export const DropDownIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 11,
  height = 7,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 11 7"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.454182 2.60642L4.42188 6.55416C5.01933 7.14861 5.98445 7.14861 6.5819 6.55416L10.5496 2.60642C11.5147 1.64616 10.8253 0 9.46193 0H1.52653C0.163115 0 -0.510933 1.64616 0.454182 2.60642Z"
        fill="white"
      />
    </svg>
  );
};
